import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab"]

  connect() {
    this.highlightCurrentTab()
  }

  highlightCurrentTab() {
    const currentPath = window.location.pathname

    this.tabTargets.forEach(tab => {
      const tabPath = tab.dataset.path
      if (!tabPath) return

      const isActive = this.isTabActive(currentPath, tabPath)

      // Toggle active/inactive classes for desktop links
      if (tab.classList.contains("student-topbar-link") || tab.classList.contains("student-topbar-link-active")) {
        tab.classList.toggle("student-topbar-link-active", isActive)
        tab.classList.toggle("student-topbar-link", !isActive)
      }

      // Toggle active/inactive classes for mobile tabs
      if (tab.classList.contains("student-tab") || tab.classList.contains("student-tab-active")) {
        tab.classList.toggle("student-tab-active", isActive)
        tab.classList.toggle("student-tab", !isActive)
      }
    })
  }

  isTabActive(currentPath, tabPath) {
    // Exact match for root
    if (tabPath === "/student" || tabPath === "/student/") {
      return currentPath === "/student" || currentPath === "/student/"
    }
    // Prefix match for sections
    return currentPath.startsWith(tabPath)
  }
}
